"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _draftExtend = require("draft-extend");

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _AtomicFocus = _interopRequireDefault(require("draft-plugins/components/AtomicFocus"));

var _InsertVideoConferenceButton = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/plugins/videoConference/InsertVideoConferenceButton"));

var _VideoConferenceComponent = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/plugins/videoConference/VideoConferenceComponent"));

var _VideoConferencePluginConstants = require("customer-data-communicator/lib/draftjs/plugins/videoConference/VideoConferencePluginConstants");

var ATOMIC_BLOCK_TYPE = 'atomic';
var VIDEO_CONFERENCE_PARENT_CLASS = 'VIDEO_CONFERENCE_PARENT_CLASS';

var isVideoConferenceBlock = function isVideoConferenceBlock(node) {
  var isDiv = node.nodeName === 'DIV';
  var hasVideoConfClassName = node.classList && node.classList.value === VIDEO_CONFERENCE_PARENT_CLASS;
  return isDiv && hasVideoConfClassName;
};

var htmlToBlock = function htmlToBlock(nodeName, node) {
  if (!isVideoConferenceBlock(node)) {
    return undefined;
  }

  return {
    type: ATOMIC_BLOCK_TYPE,
    data: {
      atomicType: _VideoConferencePluginConstants.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE,
      text: node
    }
  };
};

var blockRendererFn = function blockRendererFn(block) {
  if (block.getType() !== ATOMIC_BLOCK_TYPE || block.getData().get('atomicType') !== _VideoConferencePluginConstants.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE) {
    return undefined;
  }

  return {
    component: (0, _AtomicFocus.default)([VIDEO_CONFERENCE_PARENT_CLASS])(_VideoConferenceComponent.default),
    editable: false
  };
};

var blockToHTML = function blockToHTML(block) {
  if (block.type !== ATOMIC_BLOCK_TYPE || block.data.atomicType !== _VideoConferencePluginConstants.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE) {
    return undefined;
  }

  var textToRender = (0, _typeof2.default)(block.data.text) === 'object' ? block.data.text.innerHTML : block.data.text;
  return _react.default.createElement("div", {
    className: VIDEO_CONFERENCE_PARENT_CLASS
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: textToRender
    }
  }));
};

var keyCommandListener = function keyCommandListener(editorState, command) {
  if (command === 'backspace') {
    return _draftJs.RichUtils.onBackspace(editorState);
  }

  return undefined;
};

function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _draftExtend.createPlugin)({
    displayName: 'VideoConferencePlugin',
    buttons: (0, _InsertVideoConferenceButton.default)(props),
    blockRendererFn: blockRendererFn,
    htmlToBlock: htmlToBlock,
    blockToHTML: blockToHTML,
    keyCommandListener: keyCommandListener
  });
}

module.exports = exports.default;